import {
  PrispevokVestnikaFilter,
  PrispevokVestnikaListItem as PrispevokVestnikaListItemGenerated,
  PrispevokVestnikaListPage as PrispevokVestnikaListPageGenerated,
  PrispevokVestnikaListPageApi,
  SortDirectionEnum,
} from 'vestniky-frontend-ts-axios';
import { ClientResponse } from '../model/types/ClientResponse';
import apiConfiguration from './configuration/apiConfiguration';
import { vestnikyPrefixPath } from './configuration/apiConfigurationConstants';
import PrispevokVestnikaListFilter from '../model/PrispevokVestnikaListFilter';
import dateToString from '../function/dateToString';
import PrispevokVestnikaListItem from '../model/PrispevokVestnikaListItem';
import PrispevokVestnikaListPage from '../model/PrispevokVestnikaListPage';

const client = new PrispevokVestnikaListPageApi(apiConfiguration(vestnikyPrefixPath));

const mapPrispevok = (data: PrispevokVestnikaListItemGenerated): PrispevokVestnikaListItem => ({
  cislo: data.cislo,
  nazov: data.nazov,
  uuid: data.uuid,
  datumUcinnosti: data.datumUcinnosti ? new Date(data.datumUcinnosti) : undefined,
  datumZverejnenia: data.datumZverejnenia ? new Date(data.datumZverejnenia) : undefined,
});

const map = (data: PrispevokVestnikaListPageGenerated): PrispevokVestnikaListPage => ({
  prispevokList: data.prispevokVestnikaList.map(prispevok => mapPrispevok(prispevok)),
  number: data.number,
  size: data.size,
  totalElements: data.totalElements,
});

const mapFilterRequest = (data: PrispevokVestnikaListFilter): PrispevokVestnikaFilter => ({
  cislo: data.searchTextCislo,
  hladanyVyraz: data.searchTextVyraz,
  nazov: data.searchTextNazov,
  datumZverejneniaRok: parseInt(data.searchTextRocnik, 10),
  datumUcinnostiOd: data.datumUcinnostiOd ? dateToString(data.datumUcinnostiOd) : null,
  datumUcinnostiDo: data.datumUcinnostiDo ? dateToString(data.datumUcinnostiDo) : null,
  datumZverejneniaOd: data.datumZverejneniaOd ? dateToString(data.datumZverejneniaOd) : null,
  datumZverejneniaDo: data.datumZverejneniaDo ? dateToString(data.datumZverejneniaDo) : null,
  vestnikUuid: data.rezort?.uuid,
});

// eslint-disable-next-line import/prefer-default-export
export const fetchPrispevokVestnikaFilteredPage = async (
  filter: PrispevokVestnikaListFilter,
  page?: number,
  size?: number,
  sortBy?: string,
  sortDirection?: SortDirectionEnum,
  options?: { headers?: object },
):
  Promise<ClientResponse<PrispevokVestnikaListPage>> => {
  const {
    data,
    status,
  } = await client.getPrispevokVestnikaListPage(
    mapFilterRequest(filter),
    page,
    size,
    sortBy,
    sortDirection,
    options,
  );
  return {
    data: map(data),
    responseCode: status,
  };
};
